import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { TextArea, Input, DatePicker } from 'tea-component';
import FollowerRange from '@gp/components/FollowerRange';
import GPSelect from '@gp/components/Select';
import { ACTION_ITEM_STATUS_OPTIONS } from '@gp/constants/const';
import { getActionItemCategoryOptions } from '@gp/pages/Pipeline/utils';
import type { IBaseProps } from '@home/types/common';
import type { IGRActionItemVO } from '@gp/types/projectUpdate';
import DatePickerWrapper from '@gp/components/DatePickerWrapper';

interface IGRActionItemProps extends IBaseProps {
  index: number;
  data?: IGRActionItemVO | null;
  onDelete?: () => void;
  onChange?: (payload: Partial<IGRActionItemVO>) => void;
}

const GRActionItem: React.FC<IGRActionItemProps> = (props) => {
  const { style, className, index, data, onChange, actionItemCategory } = props;
  const {
    status,
    status_comment: statusComment,
    comment,
    due_date: dueDate,
    user_id: userId,
    user_name: userName,
    category,
  } = data || {};

  const statusCommentTrim = statusComment?.trim() || '';
  const commentTrim = comment?.trim() || '';

  const isDueDateValid = !!dueDate && !!moment(dueDate)?.isValid();
  const isStatusValid = !!status;
  const isCategoryValid = !!category;
  const isOwnerValid = !!userId && !!userName;
  const isCommentValid = !!commentTrim;
  const isStatusCommentValid = !!statusCommentTrim;
  const isActionItemValid = isDueDateValid && isStatusValid && isOwnerValid && isCommentValid && isStatusCommentValid;

  return (
    <div
      style={style}
      className={classnames('dbg-gr-action-item', className, {
        'dbg-is-error': !isActionItemValid,
      })}
    >
      <div className="dbg-gr-action-item__left">Item {index + 1}</div>
      <div className="dbg-gr-action-item__right">
        <div className="dbg-gr-action-items-form-box__item-content">
          <FollowerRange
            className={classnames({ 'dbg-is-error': !isCategoryValid })}
            label="Category"
            placeholder="Please select"
            customizePlaceholder="Please input Risks name"
            options={getActionItemCategoryOptions(actionItemCategory)}
            value={category}
            onChange={(value) => {
              onChange?.({ category: value });
            }}
          />
          <Input
            className={classnames('dbg-gr-action-items-form-control__input', {})}
            placeholder="Please input Owner"
            value={userName}
            onChange={(value) => {
              onChange?.({ user_name: value });
            }}
          />
          <div className="dbg-project-details-edit-divider">-</div>
          {/* 日期选择 */}
          <DatePickerWrapper className={classnames({ 'dbg-is-error': !isDueDateValid })} label="DUE">
            <DatePicker
              placeholder="Select Date"
              value={dueDate ? moment(dueDate) : undefined}
              onChange={(payload) => {
                const date = payload?.format('YYYY-MM-DD');
                onChange?.({ due_date: date });
              }}
            />
          </DatePickerWrapper>
          <GPSelect
            label="Status"
            clearable={false}
            options={ACTION_ITEM_STATUS_OPTIONS}
            value={status ? String(status) : ''}
            onChange={(payload) => {
              onChange?.({ status: payload });
            }}
          />
          <div className="dbg-gr-action-items-form-control__textarea-box">
            <TextArea
              placeholder="Please input comment"
              className="dbg-gr-action-items-comment-left"
              value={comment}
              onChange={(payload) => {
                onChange?.({ comment: payload });
              }}
            />
            <TextArea
              placeholder="Please input Status comment"
              value={statusComment}
              onChange={(payload) => {
                onChange?.({ status_comment: payload });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GRActionItem;
